import { useSyncExternalStore } from 'react';
import { getViewportBridge, getViewportBridgeVersion, subscribeViewportBridge } from '../utils/viewportBridge';

/** True once a model is loaded in the viewport. */
export function useViewportModelReady(): boolean {
  useSyncExternalStore(subscribeViewportBridge, getViewportBridgeVersion);
  return !!getViewportBridge()?.getModel();
}
